import { render, staticRenderFns } from "./FormulaListRight.vue?vue&type=template&id=07449648&scoped=true"
import script from "./FormulaListRight.vue?vue&type=script&lang=js"
export * from "./FormulaListRight.vue?vue&type=script&lang=js"
import style0 from "./FormulaListRight.vue?vue&type=style&index=0&id=07449648&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07449648",
  null
  
)

export default component.exports